<template>
  <component
    :is="fromWelcome || fromApiPage ? 'div' : 'v-card'"
    id="switchTeamCard"
    class="pa-4"
    flat
  >
    <v-row v-if="!fromMenu && !fromApiPage">
      <v-col
        :class="fromWelcome ? 'mt-1 mb-3 px-0' : ''"
        class="font-size-h3 darkGrey--text bold-text"
        cols="12"
      >
        Switch teams
        <div class="float-right top" v-if="fromTeamPage">
          <v-btn @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-card
        :flat="!fromWelcome"
        :outlined="fromWelcome"
        class="pb-2"
        width="100%"
      >
        <v-col cols="12">
          <v-row align="center">
            <v-col>
              <div>
                <div class="">Active teams</div>
              </div>
            </v-col>
            <v-col v-if="!fromWelcome" class="text-right">
              <v-btn
                v-if="!fromApiPage"
                :text="!$vuetify.theme.dark"
                color="primary"
                id="createNewTeamBtn"
                :outlined="$vuetify.theme.dark"
                class="text-transform-none"
                @click="createTeamModal = true"
              >
                <span class="font14 semi-bold">Create new team </span>
              </v-btn>
              <v-btn
                v-if="fromApiPage"
                id="createNewTeamBtn"
                class="text-transform-none"
                color="primary"
                icon
                @click="$emit('close')"
              >
                <v-icon v-text="'mdi-close'"></v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="py-0" cols="12">
          <v-row v-if="loading && teams.length === 0">
            <v-col v-for="i in 4" :key="i" cols="12">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-col>
          </v-row>
          <template v-else>
            <v-row
              v-for="(team, index) in teams"
              :id="`switchAbleTeamRow${team.id}`"
              :key="team.id"
              align="center"
              class="lightBackground my-3"
            >
              <v-col class="font-size-h4">
                <div>
                  {{ team.name }}
                  <div class="font11">
                    <span>Role:</span> {{ team.role }} |
                    <span> Plan: {{ team.plan }}</span>
                  </div>
                </div>
                <div v-if="team.status == 2" class="caption error--text">
                  Inactive
                </div>
              </v-col>
              <v-col class="text-right">
                <v-chip
                  v-if="fromApiPage"
                  :id="`switch${index}`"
                  :outlined="$vuetify.theme.dark"
                  class="text-transform-none"
                  color="primary"
                  label
                  @click="$emit('selected', team)"
                >
                  <div class="px-1 bold-text">Select</div>
                </v-chip>
                <template v-else>
                  <v-chip
                    v-if="getTeamId !== team.id"
                    :id="`switch${index}`"
                    :outlined="$vuetify.theme.dark"
                    class="text-transform-none"
                    color="primary"
                    label
                    @click="switchTeam(team)"
                  >
                    <div class="px-1 bold-text">Switch</div>
                  </v-chip>
                  <v-chip v-else id="currentChip" color="success" label>
                    <div class="bold-text">Current</div>
                  </v-chip>
                </template>
              </v-col>
            </v-row>
            <!-- Pagination -->
            <v-row v-if="totalPages > 1">
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-btn
                  :disabled="!hasPrevPage || loadingPage"
                  :loading="loadingPage"
                  icon
                  @click="previousPage"
                  class="mx-2"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <span class="mx-3">{{ page }} / {{ totalPages }}</span>
                <v-btn
                  :disabled="!hasNextPage || loadingPage"
                  :loading="loadingPage"
                  icon
                  @click="nextPage"
                  class="mx-2"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-card>
      <Modal
        v-model="showSuccessTeamSwitch"
        @close="showSuccessTeamSwitch = false"
      >
        <template #message>
          <v-row>
            <v-col class="my-4 font-size-h3 bold-text" cols="12">
              Switching teams
            </v-col>
            <v-col class="text-center" cols="12">
              <v-progress-circular indeterminate></v-progress-circular>
            </v-col>
            <v-col class="text-center" cols="12">Please wait...</v-col>
          </v-row>
        </template>
      </Modal>
      <Modal
        v-model="createTeamModal"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        @close="createTeamModal = false"
      >
        <template #card>
          <v-card v-if="createTeamModal">
            <v-card-title>
              <div class="darkGrey--text body-font semi-bold" cols="12">
                Create new team
              </div>
              <v-spacer></v-spacer>
              <v-btn @click="createTeamModal = false" icon>
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <create-team
                from-switch-team
                @teamCreated="afterSuccess"
              ></create-team>
            </v-card-text>
          </v-card>
        </template>
      </Modal>
    </v-row>
  </component>
</template>

<script>
import { GET_TEAMS, SWITCH_TEAM } from "@/store/team/manageTeam.module.js";
import { UPDATE_USER_TOKEN } from "@/store/users/auth.module";
import CreateTeam from "@/view/components/Team/Create.vue";
import { mapGetters } from "vuex";

export default {
  name: "team-list",
  props: {
    fromTeamPage: {
      type: Boolean,
      default: false,
    },
    fromWelcome: {
      type: Boolean,
      default: false,
    },
    fromApiPage: {
      type: Boolean,
      default: false,
    },
    fromMenu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CreateTeam,
  },
  data() {
    return {
      loading: false,
      loadingPage: false,
      modal: false,
      createTeamModal: false,
      successModalMessage: "",
      showSuccessTeamSwitch: false,
      selectedTeam: {},
      teams: [],
      meta: null,
      lastId: null,
      page: 1,
    };
  },
  computed: {
    ...mapGetters({
      getTeamId: "getTeamId",
    }),
    totalPages() {
      if (!this.meta?.count) return 1;
      return Math.ceil(this.meta.count / 4);
    },
    hasNextPage() {
      return this.meta?.count && this.teams.length < this.meta.count;
    },
    hasPrevPage() {
      return this.page > 1;
    },
  },
  created() {
    if (!this.fromWelcome) {
      this.loadTeams();
    }
  },
  methods: {
    loadTeams() {
      if (this.loading) return;
      this.loading = true;
      this.teams = [];
      this.meta = null;
      this.lastId = null;
      this.page = 1;

      this.$store
        .dispatch(GET_TEAMS)
        .then((response) => {
          const result = response.data?.[0];
          if (result) {
            this.teams = result.data || [];
            this.meta = result.meta || {};
            // Get lastId from the last NON-current team for pagination
            const nonCurrentTeams = this.teams.filter(
              (t) => t.id !== this.getTeamId
            );
            this.lastId = nonCurrentTeams[nonCurrentTeams.length - 1]?.id;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.notifyErrorMessage(err.message);
        });
    },
    nextPage() {
      if (!this.hasNextPage || this.loadingPage) return;
      this.loadingPage = true;

      this.$store
        .dispatch(GET_TEAMS, this.lastId)
        .then((response) => {
          const result = response.data?.[0];
          if (result) {
            const newTeams = result.data || [];
            // Backend pins current team to top of every page, so filter it out from new results
            const nonCurrentTeams = newTeams.filter(
              (t) => t.id !== this.getTeamId
            );
            this.teams = [...this.teams, ...nonCurrentTeams];
            this.meta = result.meta || {};
            this.lastId = nonCurrentTeams[nonCurrentTeams.length - 1]?.id;
            this.page++;
          }
          this.loadingPage = false;
        })
        .catch((err) => {
          this.loadingPage = false;
          this.notifyErrorMessage(err.message);
        });
    },
    previousPage() {
      if (!this.hasPrevPage) return;
      // Go back by removing teams added on the last page
      // Since we add 3 non-current teams per page (4 total - 1 current), remove last 3
      const teamsPerPage = 3; // 4 from API - 1 current team
      this.teams = this.teams.slice(0, -teamsPerPage);
      // Update lastId to the last non-current team
      const nonCurrentTeams = this.teams.filter((t) => t.id !== this.getTeamId);
      this.lastId = nonCurrentTeams[nonCurrentTeams.length - 1]?.id;
      this.page--;
    },
    async afterSuccess(plan) {
      this.createTeamModal = false;
      if (["Pro", "Starter"].includes(plan)) {
        await this.$router.push({ name: "team-plan" });
      } else if (this.$route.params && this.$route.params.app_id) {
        await this.$router.push({ name: "apps" });
      } else if (this.$route.name === "welcome") {
        await this.$router.push({ name: "dashboard" });
      }
      this.showSuccessTeamSwitch = true;
      this.$nextTick(() => {
        window.location.reload();
      });
    },
    switchTeam(details) {
      if (this.loading) return;
      this.loading = true;
      this.$store
        .dispatch(SWITCH_TEAM, details.id)
        .then((response) => {
          this.successModalMessage = response.data.message;
          this.afterSuccess();
          // this.$store.dispatch(CLEAR_STORE);
          this.$store.dispatch(UPDATE_USER_TOKEN, response.data.token);
          this.loading = false;
        })
        .catch((err) => {
          this.notifyErrorMessage(err.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
